<template>
    <div
        class="points-program-card relative rounded-lg flex flex-col min-h-[240px] border border-slate-200 dark:border-slate-700 shadow-sm dark:shadow-slate-900/50 overflow-hidden mb-6"
    >
        <!-- Card Content -->
        <div class="relative flex flex-col flex-1 justify-between p-5">
            <div class="flex justify-between items-start">
                <!-- Left side: Points and Program Name -->
                <div>
                    <p
                        class="text-3xl font-medium text-slate-800 dark:text-slate-100 leading-none mb-1"
                    >
                        {{ $filters.formatThousand(program.points) }}
                    </p>
                    <p class="text-sm text-slate-500 dark:text-slate-400">
                        {{ program.name }}
                    </p>
                </div>

                <!-- Right side: Program Logo -->
                <div class="shrink-0">
                    <img
                        v-if="program.image"
                        :src="getProgramImageUrl(program.image)"
                        :alt="program.name"
                        class="max-w-28 w-auto object-contain"
                    />
                </div>
            </div>

            <!-- Badges -->
            <div class="flex items-center gap-2 mt-auto">
                <span
                    class="px-3 py-1 text-xs font-medium text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 rounded-full"
                >
                    {{ programTypeName }}
                </span>
                <CppTooltip
                    :text="cppTooltipText"
                    x-placement="center"
                    y-placement="top"
                >
                    <template #trigger>
                        <span
                            class="px-3 py-1 text-xs font-medium text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 rounded-full cursor-pointer"
                        >
                            Avg CPP {{ formattedCpp || '—' }}
                        </span>
                    </template>
                </CppTooltip>
            </div>
        </div>
    </div>
</template>

<script setup>
import CppTooltip from '@/components/tooltip.vue';

const props = defineProps({
    program: {
        type: Object,
        required: true,
    },
    formattedCpp: {
        type: String,
        default: null,
    },
    cppTooltipText: {
        type: String,
        required: true,
    },
    programTypeName: {
        type: String,
        required: true,
    },
    getProgramImageUrl: {
        type: Function,
        required: true,
    },
});
</script>

<style scoped>
.points-program-card {
    background:
        linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.2) 40%,
            rgba(248, 248, 249, 0.4) 100%
        ),
        #fff url('/images/card-wave-pattern.png') right / cover no-repeat;
}
:where(.dark) .points-program-card {
    background:
        linear-gradient(
            90deg,
            rgba(15, 23, 42, 0.5) 40%,
            rgba(30, 41, 59, 0.4) 100%
        ),
        rgb(30, 41, 59) url('/images/card-wave-pattern.png') right / cover
            no-repeat;
}
</style>
